(function () {
    'use strict';

    angular
        .module('app')
        .controller('SiteMapController', SiteMapController);

    function SiteMapController($scope, $state, toaster, cfpLoadingBar) {
        var model = this;
        
        model.states = $state.get();
        //console.log(model.states);

        model.stateGo = function (state,url) {
            //console.log(state);
            if (url.indexOf(':') == -1) {
                $state.go(state);
            } else {
                toaster.pop({
                    type: 'warning',
                    title: 'Link Requirement',
                    body: 'This link requires an ID for the specific module.',
                    timeout: 5000
                });
            }
        }
        cfpLoadingBar.complete();
    }
})();
